import { Component } from "vue-property-decorator";

// Register the router hooks with thier names
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
    'beforeRouteLeave'
]);